module.exports = {
	'customFolder.m4.m410300': {
		'childrenSNames': '子女姓名',
		'childrenSAge': '子女年齡',
		'totalAppliedParentalLeaveServiceYears': '總申請育嬰留停年資',
		'applyByDate': '依日申請',
		'lessThanMonths': '未滿 6 個月',
		'moreThanMonths': '6 個月以上',
		'parentalLeaveTenure': '育嬰留停年資',
		'leaveWithoutPayHasApplied': '<%=name%>已被留職停薪套用，無法刪除',
		'leaveWithoutPayHasApplied2': '<%=name%>已被留職停薪套用，無法異動',
	},
	'customFolder.m3.m310600': {
		'childrenYearsOld': '子女<%=temp1%>年齡',
	},
	'customFolder.service.m3.service-m310600': {
		'detailedListOfEmployeeEligibilityFor': '部屬育嬰留停紀錄明細表',
	},
};
